<app-ui-checkbox
  [hasError]="uiCheckboxGroup.hasError"
  [ngModel]="uiCheckboxGroup.isChecked(value)"
  (ngModelChange)="uiCheckboxGroup.onCheckboxChange(value)"
  ><ng-content></ng-content
></app-ui-checkbox>
